"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridWrap = exports.Line = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.Line = app_1.styled.div `
  height: 1px;
  background-color: ${(theme, { $main }) => $main ? theme.colors.secondary : theme.colors.gray};
  width: 100%;
`;
exports.GridWrap = (0, app_1.styled)(ui_1.Grid) `
  min-height: 34rem;
  color: black;
  .keen-slider {
    height: 100%;
  }
  @media ${app_1.notDesktop} {
    display: flex;
    flex-direction: column;
  }
`;
